import React from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux'; // eslint-disable-line no-unused-vars
import { FiberManualRecord } from '@mui/icons-material';
import common from '~/common';

class Second extends React.Component {
  state={ over: false }

  _onClick=() => {
    const { data, history, secondPath, firstPath } = this.props;
    history.push(`${common.rootPath}/Gis/${firstPath}/${secondPath}/${data.path}`);
  }

  render () {
    const { data, history, secondPath, firstPath } = this.props;
    const isCurrent = history.location.pathname.match(`${common.rootPath}/Gis/${firstPath}/${secondPath}/${data.path}`);

    const { over } = this.state;

    return (
      <div style={{ backgroundColor: isCurrent ? '#D6ECEF' : (over ? '#a8a8a8' : 'white'), paddingLeft: 28, paddingTop: 8, paddingBottom: 8, display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={this._onClick} onMouseOver={() => this.setState({ over: true })} onMouseOut={() => this.setState({ over: false })}>
        <FiberManualRecord style={{ height: 10, width: 10, color: 'black' }} />
        <div style={{ marginLeft: 10 + 16, fontSize: 16, lineHeight: '24px', letterSpacing: '0.15%', color: isCurrent ? '#064B6F' : 'black', textAlign: 'start' }}>{data.text}</div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
});
const mapDispatchToProps = dispatch => ({
});
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Second));
